import React, {useState, useCallback} from 'react';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';

const debounce = (fn, delay) => {
  let timeoutId;
  return function(...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), delay);
  };
};

const DebounceTextField = ({onChange, delay, ...props}) => {
  const [input, setInput] = useState('');
  const debounceCallback = useCallback(
    debounce((value) => onChange(value), delay),
    []
  );
  const onInputChangeHandler = ({target: {value}}) => {
    setInput(value);
    debounceCallback(value);
  };

  return (
    <TextField
      {...props}
      onChange={onInputChangeHandler}
      value={input}
    />
  );
};

DebounceTextField.propTypes = {
  onChange: PropTypes.func,
  delay: PropTypes.number,
};

export default DebounceTextField;
